import { Tab, TabList, Tabs, Box } from '@chakra-ui/react'
import { ReactElement } from 'react'

interface CustomTagsProps {
  solidDeselected?: boolean
  name: string
  value: number
  onChange: (v: number) => void
  choices: string[] | ReactElement[]
}

const CustomTabs = ({ name, value, onChange, choices, solidDeselected }: CustomTagsProps) => {
  return (
    <Box>
      <Tabs variant="soft-rounded" index={value} size="sm">
        <TabList flexWrap="wrap" gap="6px">
          {choices.map((v: string | ReactElement, i: number) => {
            return (
              <Tab
                key={`${name}-${i}`}
                border={solidDeselected ? 'none' : '1px solid #DCE2EA'}
                fontWeight="400"
                bg={solidDeselected ? '#F5F7F9' : 'transparent'}
                h="32px"
                color="#171C22"
                _hover={{ bg: '#F5F7F9' }}
                _active={{ bg: '#d8d9dd' }}
                _selected={{
                  bg: '#171C22',
                  border: '1px solid #171C22',
                  color: 'white',
                }}
                onClick={() => {
                  if (i === value) {
                    onChange(-1)
                  } else {
                    onChange(i)
                  }
                }}
              >
                {v}
              </Tab>
            )
          })}
        </TabList>
      </Tabs>
    </Box>
  )
}

export default CustomTabs
